import { useMemo } from 'react';
import { useClientSubscription } from 'src/entities/subscription';
import { useStartBillingSubscription } from './useStartSubscription';
import { useStopBillingSubscription } from './useStopBillingSubscription';

export const useToggleSubscription = (): [() => Promise<unknown>, { isProcessing: boolean }] => {
  const { data: subscription, isLoading } = useClientSubscription();
  const [start, { isLoading: isStarting }] = useStartBillingSubscription();
  const [stop, { isLoading: isStopping }] = useStopBillingSubscription();

  const toggle = useMemo(() => {
    return subscription?.renewal ? stop : start;
  }, [subscription, start, stop]);
  const isProcessing = isLoading || isStarting || isStopping;
  return [toggle, { isProcessing }];
};
